import Vue from "vue";
import "./pollyfills";
import VueRouter from "vue-router";
import VueNotify from "vue-notifyjs";
import VeeValidate from "vee-validate";
import axios from "axios";
import VueAxios from "vue-axios";
import Storage from "vue-ls";
import VueMoment from "vue-moment";
import { ServerTable } from "vue-tables-2";
import VueAuth from "./auth";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import App from "./App.vue";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import FlagIcon from "vue-flag-icon";

// Import Helpers for filters
import {
  domain,
  count,
  pluralize,
  money,
  currencySymbol,
  humanize
} from "./filters";

// Import Install and register helper items
Vue.filter("count", count);
Vue.filter("domain", domain);
Vue.filter("pluralize", pluralize);
Vue.filter("money", money);
Vue.filter("currencySymbol", currencySymbol);
Vue.filter("humanize", humanize);

// leaflet: this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/UIComponents/SidebarPlugin";
import initProgress from "./progressbar";

// router setup
import routes from "./routes/routes";

// config setup
import config from "./config.js";

// library imports
import "./assets/sass/paper-dashboard.scss";
import "./assets/sass/element_variables.scss";
import "./assets/sass/demo.scss";
import "./assets/sass/custom.scss";

import sidebarLinks from "./sidebarLinks";

const vueTablesServerOptions = {
  filterByColumn: true,
  saveState: true,
  sortIcon: {
    base: "fa",
    up: "fa-chevron-up",
    down: "fa-chevron-down",
    is: "fa-sort"
  },
  requestAdapter: input => {
    const output = {};

    // sort
    if (input.orderBy && input.orderBy !== "") {
      output._sort = input.orderBy;

      if (input.ascending === 0) {
        output._order = "desc";
      } else {
        output._order = "asc";
      }
    }

    // paginate (limit and offset)
    output._limit = input.limit;
    output._page = input.page;

    // filter
    _.each(input.query, (val, key) => {
      if (val && val !== "") {
        output[key] = val;
      }
    });

    return output;
  },
  responseAdapter: resp => {
    let count = resp.data.length;
    if (resp.headers["x-total-count"]) {
      count = parseInt(resp.headers["x-total-count"]);
    }
    return {
      data: resp.data,
      count
    };
  }
};

window.axios = axios; // for vue tables server table

// plugin setup
Vue.use(VueRouter);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
Vue.use(VeeValidate);
Vue.use(VueAxios, axios);
Vue.use(VueMoment);
Vue.use(Storage, {
  namespace: `${config.namespace}__`, // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local" // storage name session, local, memory
});
Vue.use(
  ServerTable,
  vueTablesServerOptions,
  false,
  "bootstrap4",
  "footerPagination"
);
locale.use(lang);
Vue.use(FlagIcon);

// configure axios
Vue.axios.defaults.baseURL = config.apiBaseUrl;
Vue.axios.defaults.headers = {
  "API-Key": config.apiKey
};

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  mode: "history"
});

Vue.router = router;

Vue.use(VueAuth); // must be below 'Vue.router = router;'

initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router
});
